module.exports = __webpack_public_path__ + "img/do.19bd03ba.svg";